import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "./Onboarding.css";
import { Context } from "../../../context/Context";
import { landingContent } from "../content/landingContent";

export const Onboarding = () => {
  const { lang } = useContext(Context);
  const t = landingContent[lang] || landingContent.en;
  const { registration, steps, services, conditions } = t.onboarding;

  return (
    <section className="landing-onboarding">
      <div className="landing-registration-card">
        <div className="landing-registration-copy">
          <div className="landing-registration-price">
            <div className="landing-registration-price-label">
              {registration.priceLabel}
            </div>
            <div className="landing-registration-price-value">
              {registration.price}
            </div>
            <div className="landing-registration-price-currency">
              {registration.currency}
            </div>
            <Link
              to="/contactus"
              className="landing-btn landing-btn-primary landing-registration-cta"
            >
              {registration.cta}
            </Link>
          </div>
          <div>
            <h2>{registration.title}</h2>
            <p className="landing-registration-desc">
              {registration.description}
            </p>
            <ul className="landing-registration-features">
              {registration.features.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="landing-section-head">
        <h2>{t.onboarding.stepsTitle}</h2>
        <p>{t.onboarding.stepsSubtitle}</p>
      </div>

      <div className="landing-steps">
        {steps.map((step) => (
          <article className="landing-step" key={step.num}>
            <div className="landing-step-num">{step.num}</div>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </article>
        ))}
      </div>

      <div className="landing-services">
        <h3>{t.onboarding.servicesTitle}</h3>
        <p>{t.onboarding.servicesSubtitle}</p>

        <div className="landing-service-grid">
          {services.map((service) => (
            <div className="landing-service" key={service.num}>
              <strong>{service.title}</strong>
              <span>{service.text}</span>
              {service.tag && (
                <div className="landing-service-tag">{service.tag}</div>
              )}
            </div>
          ))}
        </div>
      </div>

      <h3 className="landing-important-title">
        {t.onboarding.conditionsTitle}
      </h3>
      <p className="landing-important-sub">{t.onboarding.conditionsSubtitle}</p>

      <div className="landing-conditions">
        {conditions.map((condition) => (
          <details className="landing-condition" key={condition.summary}>
            <summary>{condition.summary}</summary>
            <div className="landing-condition-body">
              <ul>
                {condition.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
};

export default Onboarding;
